module.exports = __webpack_public_path__ + "static/1-8f160b6e8a569f02f5c8c1b9c397fc0b.svg";